module.exports = __webpack_public_path__ + "img/ae-hero-banner.fbde8882.png";